<h4>Refine results</h4>

<div class="containerMargins">
  <p>Record types to include:</p>

  <div class="flex-container">
    <div class="column">
      <input type="checkbox" [(ngModel)]="filters.returnMerchants" /> Merchants
    </div>
    <div class="column">
      <input type="checkbox" [(ngModel)]="filters.returnBusinesses" /> Accounts
    </div>
    <div class="column">
      <input type="checkbox" [(ngModel)]="filters.returnCustomers" /> Customers
    </div>
    <div class="column">
      <input type="checkbox" [(ngModel)]="filters.returnTransactions" />
      Transactions
    </div>
    <div class="column">
      <input type="checkbox" [(ngModel)]="filters.returnUsers" /> Users
    </div>
  </div>
</div>

<div class="flex-container">
  @for (filterItem of searchFields; track filterItem) {
    <div class="column" style="margin-bottom: 15px">
      @if (filterItem.fieldType == textFieldType) {
        <div>
          <mat-form-field appearance="outline">
            <mat-label>{{ filterItem.displayName }}</mat-label>
            <input matInput type="text" [(ngModel)]="filterItem.filterValue" />
          </mat-form-field>
        </div>
      }
      @if (filterItem.fieldType == ddlFieldType) {
        <div>
          <mat-form-field appearance="outline">
            <mat-label>{{ filterItem.displayName }}</mat-label>
            <mat-select [(ngModel)]="filterItem.filterValue">
              @for (selectItem of filterItem.selectItems; track selectItem) {
                <mat-option [value]="selectItem.id">{{
                  selectItem.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
  }
</div>
